import { constructUrlWithParams, formatNumber } from '@groma-dev/scaffold';
import { AppConfig } from '../../core/AppConfig';
import { authenticatedRoutes } from '../../core/routes/AppRoutes';
import { OnboardingRoutes } from '../../core/routes/OnboardingRoutes';
import { ImageAspectRatio } from './Constants';

export const scrollToTop = () => {
  // eslint-disable-next-line no-multi-assign
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};

export const jumpToAnchorRef = () => {
  let counter = 0;

  const interval = setInterval(() => {
    if (counter === 10) clearInterval(interval);

    findElement();
    counter++;
  }, 500);

  const findElement = () => {
    const { hash } = window.location;
    const el = document.getElementById(hash?.split('#')[1]);

    if (el) {
      if (interval) clearInterval(interval);
      el.scrollIntoView(true);
    }
  };

  findElement();
};

export const isAuthenticatedRoute = (route: string) => {
  return Object.values(authenticatedRoutes).includes(route);
};

export const isOnboardingRoute = (pathname: string) => {
  return Object.values(OnboardingRoutes).some(route => pathname.startsWith(route));
};

export const buildUrlWithParams = (url: string) => {
  const { allowList } = AppConfig.Settings.Routing.searchParams;
  return constructUrlWithParams(url, { persistList: allowList });
};

export const buildImageUrl = (url: string, ratio?: ImageAspectRatio) => {
  return `${url}${ratio ? `?crop=${ratio}` : ''}`;
};

export const bankersRound = (value: number, decimals: number): number => {
  const factor = 10 ** decimals;
  const shifted = value * factor;
  const truncated = Math.trunc(shifted);
  const remainder = Math.abs(shifted - truncated);

  if (Math.abs(remainder - 0.5) < 1e-9) {
    return (truncated % 2 === 0 ? truncated : truncated + Math.sign(shifted)) / factor;
  }

  return Math.round(shifted) / factor;
};

export const isValidEmail = (email: string) => {
  const emailRegex = /^\S+@\S+\.\S+$/;
  return emailRegex.test(email);
};

const GROMACOIN_DECIMALS = 18;

export const formatGromaCoinAmount = (amount: string): string =>
  formatNumber(amount, { maximumFractionDigits: GROMACOIN_DECIMALS });

const TRUNCATION_PREFIX_LENGTH = 6;
const TRUNCATION_SUFFIX_LENGTH = 4;

export const truncateWalletAddress = (address: string): string => {
  if (address.length <= TRUNCATION_PREFIX_LENGTH + TRUNCATION_SUFFIX_LENGTH) {
    return address;
  }
  return `${address.slice(0, TRUNCATION_PREFIX_LENGTH)}...${address.slice(-TRUNCATION_SUFFIX_LENGTH)}`;
};
